// extracted by mini-css-extract-plugin
export var dataCell = "_rs-2";
export var dataRow = "_rs-0";
export var headerRow = "_rs-1";